export function PostLayoutDivider() {
  return <dl className="my-12 flex border-t border-slate-800" />
}
